// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/bare-necessities.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const bareNecessities: Score = {
  slug: "bare-necessities",
  n: 5,
  title: "Bare Necessities",
  composer: "Terry Gilkyson",
  rights: "in-copyright",
  publicSafe: false,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 112,
  staves: 1,
  clefs: ["treble"],
  bars: 17,
  barQuarters: 4.0,
  lowest: 67,
  highest: 81,
  hasLyrics: true,
  jasonNote: "Here's the hit song from \"The Jungle Book\". It's always nice to sing along while you play. And tap your foot of course! Watch out for beat 1. It's a rest and that means you start from beat 2.",
  teaches: ["entry on beat 2 after a beat-1 rest", "syncopation", "singing while playing"],
  art: "/sight-reading/art/bare-necessities.jpg",
  artRights: "studio",
  background: "/sight-reading/bg/bare-necessities.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "Look" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter", lyric: "for" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", lyric: "the" },
    { bar: 2, hand: "rh", start: 4.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 2, hand: "rh", start: 5.0, dur: 2.0, midi: 76, pitch: "E5", d: "half", lyric: "Bare" },
    { bar: 2, hand: "rh", start: 7.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter", lyric: "ne" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter", lyric: "ce" },
    { bar: 3, hand: "rh", start: 9.0, dur: 0.5, midi: 74, pitch: "D5", d: "eighth", lyric: "ssi" },
    {
  bar: 3,
  hand: "rh",
  start: 9.5,
  dur: 0.5,
  midi: 72,
  pitch: "C5",
  d: "eighth",
  tie: "start",
  lyric: "Ties"
},
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", tie: "stop" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", lyric: "the" },
    { bar: 4, hand: "rh", start: 12.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter", lyric: "sim" },
    { bar: 4, hand: "rh", start: 13.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", lyric: "ple" },
    {
  bar: 4,
  hand: "rh",
  start: 14.0,
  dur: 1.0,
  midi: 74,
  pitch: "D5",
  d: "quarter",
  lyric: "Bare"
},
    { bar: 4, hand: "rh", start: 15.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", lyric: "Ne" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter", lyric: "ce" },
    { bar: 5, hand: "rh", start: 17.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth", lyric: "ssi" },
    {
  bar: 5,
  hand: "rh",
  start: 17.5,
  dur: 0.5,
  midi: 69,
  pitch: "A4",
  d: "eighth",
  tie: "start",
  lyric: "ties"
},
    { bar: 5, hand: "rh", start: 18.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter", tie: "stop" },
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "for" },
    { bar: 6, hand: "rh", start: 20.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", lyric: "get" },
    { bar: 6, hand: "rh", start: 21.0, dur: 0.75, rest: true, d: "eighth", dot: true },
    { bar: 6, hand: "rh", start: 21.75, dur: 0.25, midi: 67, pitch: "G4", d: "16th", lyric: "a" },
    {
  bar: 6,
  hand: "rh",
  start: 22.0,
  dur: 1.0,
  midi: 72,
  pitch: "C5",
  d: "quarter",
  lyric: "bout"
},
    {
  bar: 6,
  hand: "rh",
  start: 23.0,
  dur: 1.0,
  midi: 76,
  pitch: "E5",
  d: "quarter",
  lyric: "your"
},
    { bar: 7, hand: "rh", start: 24.0, dur: 1.0, midi: 81, pitch: "A5", d: "quarter", lyric: "wor" },
    {
  bar: 7,
  hand: "rh",
  start: 25.0,
  dur: 1.0,
  midi: 79,
  pitch: "G5",
  d: "quarter",
  lyric: "ries"
},
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 77, pitch: "F5", d: "quarter", lyric: "and" },
    {
  bar: 7,
  hand: "rh",
  start: 27.0,
  dur: 1.0,
  midi: 76,
  pitch: "E5",
  d: "quarter",
  lyric: "your"
},
    {
  bar: 8,
  hand: "rh",
  start: 28.0,
  dur: 4.0,
  midi: 74,
  pitch: "D5",
  d: "whole",
  tie: "start",
  lyric: "strife"
},
    { bar: 9, hand: "rh", start: 32.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter", tie: "stop" },
    { bar: 9, hand: "rh", start: 33.0, dur: 1.0, midi: 79, pitch: "G5", d: "quarter", lyric: "I" },
    {
  bar: 9,
  hand: "rh",
  start: 34.0,
  dur: 1.0,
  midi: 81,
  pitch: "A5",
  d: "quarter",
  lyric: "mean"
},
    { bar: 9, hand: "rh", start: 35.0, dur: 1.0, midi: 79, pitch: "G5", d: "quarter", lyric: "the" },
    { bar: 10, hand: "rh", start: 36.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 10, hand: "rh", start: 37.0, dur: 2.0, midi: 81, pitch: "A5", d: "half", lyric: "bare" },
    { bar: 10, hand: "rh", start: 39.0, dur: 1.0, midi: 79, pitch: "G5", d: "quarter", lyric: "ne" },
    { bar: 11, hand: "rh", start: 40.0, dur: 1.0, midi: 81, pitch: "A5", d: "quarter", lyric: "ce" },
    { bar: 11, hand: "rh", start: 41.0, dur: 0.5, midi: 79, pitch: "G5", d: "eighth", lyric: "ssi" },
    {
  bar: 11,
  hand: "rh",
  start: 41.5,
  dur: 0.5,
  midi: 76,
  pitch: "E5",
  d: "eighth",
  tie: "start",
  lyric: "Ties"
},
    { bar: 11, hand: "rh", start: 42.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter", tie: "stop" },
    {
  bar: 11,
  hand: "rh",
  start: 43.0,
  dur: 1.0,
  midi: 72,
  pitch: "C5",
  d: "quarter",
  lyric: "old"
},
    { bar: 12, hand: "rh", start: 44.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter", lyric: "mo" },
    {
  bar: 12,
  hand: "rh",
  start: 45.0,
  dur: 1.0,
  midi: 72,
  pitch: "C5",
  d: "quarter",
  lyric: "ther"
},
    { bar: 12, hand: "rh", start: 46.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter", lyric: "na" },
    {
  bar: 12,
  hand: "rh",
  start: 47.0,
  dur: 1.0,
  midi: 72,
  pitch: "C5",
  d: "quarter",
  lyric: "ture"
},
    { bar: 13, hand: "rh", start: 48.0, dur: 1.0, midi: 79, pitch: "G5", d: "quarter", lyric: "re" },
    { bar: 13, hand: "rh", start: 49.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth", lyric: "ci" },
    {
  bar: 13,
  hand: "rh",
  start: 49.5,
  dur: 0.5,
  midi: 72,
  pitch: "C5",
  d: "eighth",
  tie: "start",
  lyric: "Pies"
},
    { bar: 13, hand: "rh", start: 50.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", tie: "stop" },
    {
  bar: 13,
  hand: "rh",
  start: 51.0,
  dur: 1.0,
  midi: 74,
  pitch: "D5",
  d: "quarter",
  lyric: "that"
},
    {
  bar: 14,
  hand: "rh",
  start: 52.0,
  dur: 1.0,
  midi: 76,
  pitch: "E5",
  d: "quarter",
  lyric: "bring"
},
    {
  bar: 14,
  hand: "rh",
  start: 53.0,
  dur: 1.0,
  midi: 79,
  pitch: "G5",
  d: "quarter",
  lyric: "the"
},
    {
  bar: 14,
  hand: "rh",
  start: 54.0,
  dur: 1.0,
  midi: 76,
  pitch: "E5",
  d: "quarter",
  lyric: "bare"
},
    { bar: 14, hand: "rh", start: 55.0, dur: 1.0, midi: 79, pitch: "G5", d: "quarter", lyric: "ne" },
    { bar: 15, hand: "rh", start: 56.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter", lyric: "ce" },
    { bar: 15, hand: "rh", start: 57.0, dur: 0.5, midi: 72, pitch: "C5", d: "eighth", lyric: "ssi" },
    {
  bar: 15,
  hand: "rh",
  start: 57.5,
  dur: 0.5,
  midi: 69,
  pitch: "A4",
  d: "eighth",
  tie: "start",
  lyric: "ties"
},
    { bar: 15, hand: "rh", start: 58.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter", tie: "stop" },
    { bar: 15, hand: "rh", start: 59.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "of" },
    { bar: 16, hand: "rh", start: 60.0, dur: 4.0, midi: 72, pitch: "C5", d: "whole", lyric: "life" },
    { bar: 17, hand: "rh", start: 64.0, dur: 4.0, rest: true, d: "whole" },
  ],
};
